import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

import { DesktopNotificationService } from '../services/desktop-notification.service';
import * as notificationActions from './notification.actions';

@Injectable()
export class DesktopNotificationEffects {
  constructor(
    private actions$: Actions,
    private desktopNotificationService: DesktopNotificationService,
  ) {
    this.desktopNotificationService.start();
  }

  // ─── Desktop Delivery ──────────────────────────────────────────────────────

  userEventReceived$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(notificationActions.UserEventReceived),
        tap(({ event }) => void this.desktopNotificationService.deliver(event)),
      ),
    { dispatch: false },
  );
}
